<template>
  <section
    v-reveal
    :id="anchorId"
    class="v2-recent"
  >
    <div class="v2-recent__container">
      <div class="v2-recent__header">
        <span class="v2-recent__eyebrow">{{ eyebrow }}</span>
        <h2 class="v2-recent__title">{{ headline }}</h2>
      </div>

      <!-- V2-styled activity feed — real data from legacy API,
           Lovable aesthetics, new 3-tab layout. -->
      <v2-campaign-activities :campaign-id="String(campaign.id)" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'V2RecentActivity',
  props: {
    campaign: { type: Object, required: true },
    activitySection: { type: Object, default: () => ({}) },
    anchorId: { type: String, default: 'activity' },
  },
  computed: {
    eyebrow() {
      return this.activitySection?.eyebrow || 'Recent Activity'
    },
    headline() {
      return this.activitySection?.headline || 'The Community in Action'
    },
  },
}
</script>

<style scoped>
.v2-recent {
  background: var(--sideout-surface); /* bg-muted */
  padding-top: 64px;
  padding-bottom: 64px;
}
@media (min-width: 1024px) {
  .v2-recent { padding-top: 96px; padding-bottom: 96px; }
}
.v2-recent__container {
  max-width: 1400px;
  margin-inline: auto;
  padding-inline: 24px;
}
@media (min-width: 768px)  { .v2-recent__container { padding-inline: 48px; } }
@media (min-width: 1024px) { .v2-recent__container { padding-inline: 64px; } }

.v2-recent__header {
  text-align: center;
  margin-bottom: 48px;
}
.v2-recent__eyebrow {
  display: inline-block;
  color: var(--sideout-pink);
  font-family: 'Red Hat Display', sans-serif;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  line-height: 24px;
}
.v2-recent__title {
  margin-top: 12px;
  color: var(--sideout-navy);
  font-family: 'Red Hat Display', sans-serif;
  font-size: 30px;
  line-height: 1.1;
  font-weight: 800;
  text-wrap: balance;
}
@media (min-width: 768px) {
  .v2-recent__title { font-size: 48px; }
}
</style>
